import { Navigate } from 'react-router';
import { useAuthStore } from '@/store/useAuthStore';
import { getToken, isTokenExpired } from '@/helper/auth';

export const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const user = useAuthStore(state => state.user);
  const token = getToken();

  if (!isAuthenticated || !user?.isVerified || !token || isTokenExpired(token)) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isOnboarded) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};
